module.exports = __webpack_public_path__ + "static/Segments-voter.b4f24827.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Segments-voter.png
// module id = 508
// module chunks = 265584890008614